import React, { useState } from "react";
import { gql, useMutation, useApolloClient } from "@apollo/client";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/PiecePerduDesktop.css";

// =====================
// 🔹 Mutations Déclaration
// =====================

// Carte d'identité perdue
const INSERT_CARTE_IDENTITE_PERDUE = gql`
  mutation InsertCarteIdentitePerdue(
    $lieu_vote: String!,
    $adresse: String!,
    $nom: String!,
    $prenom: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $telephone: String!
  ) {
    insert_carte_identite_perdue_one(object: {
      lieu_vote: $lieu_vote,
      adresse: $adresse,
      nom: $nom,
      prenom: $prenom,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

// Carte étudiant perdue
const INSERT_CARTE_ETUDIANT_PERDUE = gql`
  mutation InsertCarteEtudiantPerdue(
    $ine: String!,
    $ecole_rattachement: String!,
    $nom: String!,
    $prenom: String!,
    $filiere: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $telephone: String!
  ) {
    insert_carte_etudiant_perdue_one(object: {
      ine: $ine,
      ecole_rattachement: $ecole_rattachement,
      nom: $nom,
      prenom: $prenom,
      filiere: $filiere,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

// Passeport perdu
const INSERT_PASSEPORT_PERDU = gql`
  mutation InsertPasseportPerdu(
    $nom: String!,
    $prenom: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $nationalite: String!,
    $telephone: String!
  ) {
    insert_passeport_perdu_one(object: {
      nom: $nom,
      prenom: $prenom,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      nationalite: $nationalite,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

// Permis perdu
const INSERT_PERMIS_PERDU = gql`
  mutation InsertPermisPerdu(
    $nom: String!,
    $prenom: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $categories: String!,
    $adresse: String!,
    $telephone: String!
  ) {
    insert_permis_perdu_one(object: {
      nom: $nom,
      prenom: $prenom,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      categories: $categories,
      adresse: $adresse,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

// Carte de commerce perdue
const INSERT_CARTE_COMMERCE_PERDUE = gql`
  mutation InsertCarteCommercePerdue(
    $nom: String!,
    $prenom: String!,
    $profession: String!,
    $numero_agrement: String!,
    $telephone: String!
  ) {
    insert_carte_commerce_perdue_one(object: {
      nom: $nom,
      prenom: $prenom,
      profession: $profession,
      numero_agrement: $numero_agrement,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

// Carte professionnelle perdue
const INSERT_CARTE_PROFESSIONNELLE_PERDUE = gql`
  mutation InsertCarteProfessionnellePerdue(
    $nom: String!,
    $prenom: String!,
    $matricule: String!,
    $telephone: String!
  ) {
    insert_carte_professionnelle_perdue_one(object: {
      nom: $nom,
      prenom: $prenom,
      matricule: $matricule,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

// Carte grise perdue
const INSERT_CARTE_GRISE_PERDUE = gql`
  mutation InsertCarteGrisePerdue(
    $nom: String!,
    $prenom: String!,
    $numero_plaque: String!,
    $marque_modele: String!,
    $telephone: String!
  ) {
    insert_carte_grise_perdue_one(object: {
      nom: $nom,
      prenom: $prenom,
      numero_plaque: $numero_plaque,
      marque_modele: $marque_modele,
      telephone: $telephone
    }) {
      id
      nom
      prenom
    }
  }
`;

// Autre document perdu
const INSERT_AUTRE_DOCUMENT_PERDU = gql`
  mutation InsertAutreDocumentPerdu(
    $nom: String!,
    $prenom: String!,
    $type_document: String!,
    $date_naissance: date!,
    $lieu_naissance: String!,
    $telephone: String!,
    $description: String
  ) {
    insert_autre_document_perdu_one(object: {
      nom: $nom,
      prenom: $prenom,
      type_document: $type_document,
      date_naissance: $date_naissance,
      lieu_naissance: $lieu_naissance,
      telephone: $telephone,
      description: $description
    }) {
      id
      nom
      prenom
    }
  }
`;

// =====================
// 🔹 Vérifications doublons
// =====================
const CHECK_CARTE_IDENTITE_PERDUE = gql`
  query CheckCarteIdentitePerdue($nom: String!, $prenom: String!, $date_naissance: date!) {
    carte_identite_perdue(
      where: {
        nom: { _eq: $nom },
        prenom: { _eq: $prenom },
        date_naissance: { _eq: $date_naissance }
      }
    ) {
      id
    }
  }
`;

const CHECK_CARTE_ETUDIANT_PERDUE = gql`
  query CheckCarteEtudiantPerdue($ine: String!) {
    carte_etudiant_perdue(where: { ine: { _eq: $ine } }) {
      id
    }
  }
`;

// =====================
// 🔹 Composant principal
// =====================

const PiecePerduDesktop = () => {
  const client = useApolloClient();
  const [selectedType, setSelectedType] = useState("");
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    type_document: "",
    date_naissance: "",
    lieu_naissance: "",
    description: "",
    lieu_vote: "",
    adresse: "",
    ine: "",
    ecole_rattachement: "",
    filiere: "",
    nationalite: "",
    categories: "",
    profession: "",
    numero_agrement: "",
    matricule: "",
    numero_plaque: "",
    marque_modele: "",
    etat: "",
    telephone: "",
  });

  const [insertCarteIdentite] = useMutation(INSERT_CARTE_IDENTITE_PERDUE);
  const [insertCarteEtudiant] = useMutation(INSERT_CARTE_ETUDIANT_PERDUE);
  const [insertPasseport] = useMutation(INSERT_PASSEPORT_PERDU);
  const [insertPermis] = useMutation(INSERT_PERMIS_PERDU);
  const [insertCarteCommerce] = useMutation(INSERT_CARTE_COMMERCE_PERDUE);
  const [insertCarteProfessionnelle] = useMutation(INSERT_CARTE_PROFESSIONNELLE_PERDUE);
  const [insertCarteGrise] = useMutation(INSERT_CARTE_GRISE_PERDUE);
  const [insertAutreDocumentPerdu] = useMutation(INSERT_AUTRE_DOCUMENT_PERDU);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const resetForm = () => {
    setFormData({
      nom: "",
      prenom: "",
      type_document: "",
      date_naissance: "",
      lieu_naissance: "",
      description: "",
      lieu_vote: "",
      adresse: "",
      ine: "",
      ecole_rattachement: "",
      filiere: "",
      nationalite: "",
      categories: "",
      profession: "",
      numero_agrement: "",
      matricule: "",
      numero_plaque: "",
      marque_modele: "",
      etat: "",
      telephone: "",
    });
    setSelectedType("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedDate = formData.date_naissance
      ? new Date(formData.date_naissance).toISOString().split("T")[0]
      : "";

    try {
      if (selectedType === "carte_identite") {
        const check = await client.query({
          query: CHECK_CARTE_IDENTITE_PERDUE,
          variables: {
            nom: formData.nom,
            prenom: formData.prenom,
            date_naissance: formattedDate,
          },
          fetchPolicy: "network-only",
        });
        if (check.data.carte_identite_perdue.length > 0) {
          toast.error("⚠️ Cette carte d'identité est déjà déclarée.");
          return;
        }
        await insertCarteIdentite({
          variables: { ...formData, date_naissance: formattedDate },
        });
      } else if (selectedType === "carte_etudiant") {
        const check = await client.query({
          query: CHECK_CARTE_ETUDIANT_PERDUE,
          variables: { ine: formData.ine },
          fetchPolicy: "network-only",
        });
        if (check.data.carte_etudiant_perdue.length > 0) {
          toast.error("⚠️ Cette carte étudiant est déjà déclarée.");
          return;
        }
        await insertCarteEtudiant({
          variables: { ...formData, date_naissance: formattedDate },
        });
      } else if (selectedType === "passeport") {
        await insertPasseport({
          variables: { ...formData, date_naissance: formattedDate },
        });
      } else if (selectedType === "permis") {
        await insertPermis({
          variables: { ...formData, date_naissance: formattedDate },
        });
      } else if (selectedType === "carte_commerce") {
        await insertCarteCommerce({
          variables: {
            nom: formData.nom,
            prenom: formData.prenom,
            profession: formData.profession,
            numero_agrement: formData.numero_agrement,
            telephone: formData.telephone,
          },
        });
      } else if (selectedType === "carte_professionnelle") {
        await insertCarteProfessionnelle({
          variables: {
            nom: formData.nom,
            prenom: formData.prenom,
            matricule: formData.matricule,
            telephone: formData.telephone,
          },
        });
      } else if (selectedType === "carte_grise") {
        await insertCarteGrise({
          variables: {
            nom: formData.nom,
            prenom: formData.prenom,
            numero_plaque: formData.numero_plaque,
            marque_modele: formData.marque_modele,
            telephone: formData.telephone,
          },
        });
      } else if (selectedType === "autre_document_perdue") {
        await insertAutreDocumentPerdu({
          variables: { ...formData, date_naissance: formattedDate },
        });
      } else {
        toast.error("⚠️ Veuillez sélectionner un type de document !");
        return;
      }

      toast.success("✅ Déclaration enregistrée avec succès !");
      resetForm();
    } catch (error) {
      console.error("Erreur lors de l'insertion :", error);
      toast.error("❌ Une erreur est survenue !");
    }
  };

  return (
    <div className="page-shell lost-page">
      <Header />

      <main className="piece-wrapper">
        {/* HERO */}
        <section className="page-hero">
          <div>
            <p className="eyebrow">_________________</p>
            <h2 className="title">Déclarer un document perdu</h2>
            <p className="intro-text">
              Renseignez le type de pièce et les informations essentielles
              pour que notre équipe puisse vous aider à la retrouver rapidement.
            </p>
          </div>
          <a
            href="https://wa.me/221777600767"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-badge"
            style={{ color: "#ffffff", textDecoration: "none" }}
          >
            Assistance 7j/7
          </a>
        </section>

        {/* ÉTAPE 1 : TYPE DE DOCUMENT */}
        <section className="card">
          <div className="section-header">
            <div>
              <p className="eyebrow">Type de document</p>
              <h3 className="section-title">Choisissez le document à déclarer</h3>
              <p className="section-description">
                Sélectionnez la pièce concernée pour afficher uniquement les champs
                nécessaires et gagner du temps.
              </p>
            </div>
            <div className="pill">Étape 1/2</div>
          </div>

          <div className="field compact-field">
            <label>Type de document</label>
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              required
            >
              <option value="">-- Sélectionner --</option>
              <option value="carte_identite">Carte d'Identité</option>
              <option value="carte_etudiant">Carte Étudiant</option>
              <option value="passeport">Passeport</option>
              <option value="permis">Permis</option>
              <option value="carte_commerce">Carte de Commerce</option>
              <option value="carte_professionnelle">Carte Professionnelle</option>
              <option value="carte_grise">Carte Grise</option>
              <option value="autre_document_perdue">Autre Document</option>
            </select>
          </div>
        </section>

        {/* ÉTAPE 2 : FORMULAIRE */}
        {selectedType && (
          <section className="card">
            <div className="section-header">
              <div>
                <p className="eyebrow">Informations</p>
                 <center><h3 className="section-title">
                  Renseignez les détails du titulaire
                </h3></center>
                <p className="section-description">
                  Les champs marqués d'une astérisque sont obligatoires.
                  Merci de fournir des informations précises pour faciliter les recherches.
                </p>
              </div>
              <div className="pill">Étape 2/2</div>
            </div>

            <form className="form" onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="field">
                  <label>Nom *</label>
                  <input
                    type="text"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field">
                  <label>Prénom *</label>
                  <input
                    type="text"
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field">
                  <label>Téléphone *</label>
                  <input
                    type="tel"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    required
                    placeholder="Ex: 771234567"
                    pattern="[0-9]{9,}"
                  />
                </div>

                {!(
                  selectedType === "carte_commerce" ||
                  selectedType === "carte_professionnelle" ||
                  selectedType === "carte_grise"
                ) && (
                  <>
                    <div className="field">
                      <label>Date de naissance *</label>
                      <input
                        type="date"
                        name="date_naissance"
                        value={formData.date_naissance}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="field">
                      <label>Lieu de naissance *</label>
                      <input
                        type="text"
                        name="lieu_naissance"
                        value={formData.lieu_naissance}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </>
                )}

                {selectedType === "carte_identite" && (
                  <>
                    <div className="field">
                      <label>Lieu de vote</label>
                      <input
                        type="text"
                        name="lieu_vote"
                        value={formData.lieu_vote}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="field">
                      <label>Adresse</label>
                      <input
                        type="text"
                        name="adresse"
                        value={formData.adresse}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "carte_etudiant" && (
                  <>
                    <div className="field">
                      <label>INE *</label>
                      <input
                        type="text"
                        name="ine"
                        value={formData.ine}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>École de rattachement *</label>
                      <input
                        type="text"
                        name="ecole_rattachement"
                        value={formData.ecole_rattachement}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>Filière</label>
                      <input
                        type="text"
                        name="filiere"
                        value={formData.filiere}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "passeport" && (
                  <div className="field">
                    <label>Nationalité *</label>
                    <input
                      type="text"
                      name="nationalite"
                      value={formData.nationalite}
                      onChange={handleChange}
                      required
                    />
                  </div>
                )}

                {selectedType === "permis" && (
                  <>
                    <div className="field">
                      <label>Catégories *</label>
                      <input
                        type="text"
                        name="categories"
                        value={formData.categories}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>Adresse</label>
                      <input
                        type="text"
                        name="adresse"
                        value={formData.adresse}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "carte_commerce" && (
                  <>
                    <div className="field">
                      <label>Profession *</label>
                      <input
                        type="text"
                        name="profession"
                        value={formData.profession}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>Numéro d'agrément</label>
                      <input
                        type="text"
                        name="numero_agrement"
                        value={formData.numero_agrement}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "carte_professionnelle" && (
                  <div className="field">
                    <label>Matricule</label>
                    <input
                      type="text"
                      name="matricule"
                      value={formData.matricule}
                      onChange={handleChange}
                    />
                  </div>
                )}

                {selectedType === "carte_grise" && (
                  <>
                    <div className="field">
                      <label>Numéro de plaque</label>
                      <input
                        type="text"
                        name="numero_plaque"
                        value={formData.numero_plaque}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="field">
                      <label>Marque et modèle</label>
                      <input
                        type="text"
                        name="marque_modele"
                        value={formData.marque_modele}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {selectedType === "autre_document_perdue" && (
                  <>
                    <div className="field">
                      <label>Type de document</label>
                      <input
                        type="text"
                        name="type_document"
                        value={formData.type_document}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="field full-row">
                      <label>Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}
              </div>

              <div className="button-row">
                <button type="submit">Soumettre la déclaration</button>
              </div>
            </form>
          </section>
        )}
      </main>

      <Footer />

      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
};

export default PiecePerduDesktop;